/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Donate CRM customize test after DOM render
  donate_crm();

  // Evolving function for WCAG guidelines
  v8_wcag();

  // Detect Internet Explorer
  detect_IE();

  leaving_site();
  pdf_link();

  // Detect Native Android Browser
  detect_native_android_browser();

  // Apple Device Detect
  device_detect();

  // Gravity Forms Placeholder Clearing
  // gravity_forms_placeholders();

  // Custom DD Slick Dropdown Menus (Select Box Replacement)
  // ddslick();

  // Inline SVG replacement
  // inline_svg_replacement();

  // Isotope Masonry
  // isotope_masonry();

  // Event Target Testing
  jQuery( document ).click(function(event) {

  });

  // Window scroll detection
  jQuery(window).bind("scroll", function(event) {

  });

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

  //iconmenu_svg_animation();

  // Menu offcanvas add class to body

  jQuery('#open-offcanvas').click(function() {
      jQuery('body').addClass('opened-offcanvas-fullmenu');
  });
  jQuery('.offcanvas-full-screen-close').click(function() {
      jQuery('body').removeClass('opened-offcanvas-fullmenu');
  });
  jQuery('#open-offcanvas-mobile').click(function() {
      jQuery('body').toggleClass('opened-offcanvas-fullmenu');
  });

});

setTimeout(function(){
  donate_crm();
},2000);


function donate_crm() {
  if (jQuery('#bbox-root').hasClass('ada-kik')) {

    jQuery('img.BBCardImage').attr('alt', 'Alternative text');

  }
}
